import gql from 'graphql-tag'

export default gql`
  query getAllVouchers {
    getAllVouchers {
      gift_vouchers {
        id
        img_url
        name
        sku
        url_key
        categories
        keywords
        description
        merchant_id
      }
    }
  }
`
